var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#208177"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100,100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-40,-10 C-40,-45 40,-45 40,-10",
    stroke: "#FFFFFF",
    strokeWidth: 8,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -48,
    y: -15,
    width: 16,
    height: 35,
    rx: 8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: -15,
    width: 16,
    height: 35,
    rx: 8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,10 C32,10 25,30 10,35",
    stroke: "#FFFFFF",
    strokeWidth: 6,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 37,
    r: 7,
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerAvatar);
export default __webpack_public_path__ + "static/media/customer_avatar.e68efeceb6e21a7150e822d548b658a2.svg";
export { ForwardRef as ReactComponent };